<template>
    <div>
        <v-layout row>
            <v-flex xs12>
                <v-container grid-list-xl fluid>
                    <v-alert
                            :value="upgradeRequired"
                            color="warning"
                            icon="priority_high"
                            outline
                    >
                        This company profile has not been upgraded. Emulation and editing are disabled temporarily.
                    </v-alert>
                    <v-layout row wrap>
                        <v-flex xs12 class="text-xs-right" v-if="!upgradeRequired">
                            <v-btn :to="{name: 'admin.company.profile.name', params: {uid: company.uid}}">Edit Company
                                Name
                            </v-btn>
                            <v-btn :href="emulateURL" color="primary" target="_blank">Emulate</v-btn>
                        </v-flex>
                        <!--Contact-->
                        <v-flex xs12 md6 lg4>
                            <h5>Primary Contact</h5>
                            <table>
                                <tbody>
                                <tr>
                                    <td>Name:&nbsp;</td>
                                    <td>{{ company.profile.contacts.primary.firstName }} {{
                                        company.profile.contacts.primary.lastName }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Telephone:&nbsp;</td>
                                    <td>{{ company.profile.contacts.primary.telephone }}</td>
                                </tr>
                                <tr>
                                    <td>Mobile:&nbsp;</td>
                                    <td>{{ company.profile.contacts.primary.mobile }}</td>
                                </tr>
                                <tr>
                                    <td>Email:&nbsp;</td>
                                    <td>{{ company.profile.contacts.primary.email }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <v-btn v-if="!upgradeRequired" :to="{name: 'admin.company.profile.contact', params: {uid: company.uid}}" block>Edit
                                Contact
                            </v-btn>
                        </v-flex>
                        <!--Address-->
                        <v-flex xs12 md6>
                            <v-layout row>
                                <v-flex xs6>
                                    <h5>Delivery Address</h5>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>{{ company.profile.addresses.delivery.address1 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.delivery.address2 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.delivery.address3 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.delivery.city }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.delivery.county">
                                            <td>{{ company.profile.addresses.delivery.county }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.delivery.state">
                                            <td>{{ company.profile.addresses.delivery.state }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.delivery.postCode">
                                            <td>{{ company.profile.addresses.delivery.postCode }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.delivery.country }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs6>
                                    <h5>Billing Address</h5>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>{{ company.profile.addresses.billing.address1 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.billing.address2 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.billing.address3 }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.billing.city }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.billing.county">
                                            <td>{{ company.profile.addresses.billing.county }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.billing.state">
                                            <td>{{ company.profile.addresses.billing.state }}</td>
                                        </tr>
                                        <tr v-if="company.profile.addresses.billing.postCode">
                                            <td>{{ company.profile.addresses.billing.postCode }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ company.profile.addresses.billing.country }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-layout>
                            <v-btn v-if="!upgradeRequired" :to="{name: 'admin.company.profile.address', params: {uid: company.uid}}" block>Edit
                                Address
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                            <h5>About Us</h5>
                            <table>
                                <tbody>
                                <tr>
                                    <td>Year Founded:&nbsp;</td>
                                    <td>{{ company.profile.stats.yearFounded }}</td>
                                </tr>
                                <tr>
                                    <td>Number of Employees:&nbsp;</td>
                                    <td>{{ company.profile.stats.size }}</td>
                                </tr>
                                <tr>
                                    <td>Turnover:&nbsp;</td>
                                    <td>{{ turnoverPretty }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <v-btn v-if="!upgradeRequired" :to="{name: 'admin.company.profile.stats', params: {uid: company.uid}}" block>Edit
                                About Us
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                            <h5>Social Media</h5>
                            <template v-if="company.profile.socialMedia">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>Website:&nbsp;</td>
                                        <td>{{ company.profile.socialMedia.website }}</td>
                                    </tr>
                                    <tr>
                                        <td>Facebook:&nbsp;</td>
                                        <td>{{ company.profile.socialMedia.facebook }}</td>
                                    </tr>
                                    <tr>
                                        <td>Twitter:&nbsp;</td>
                                        <td>{{ company.profile.socialMedia.twitter }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </template>
                            <p v-else>No social media links configured</p>
                            <v-btn v-if="!upgradeRequired" :to="{name: 'admin.company.profile.socialMedia', params: {uid: company.uid}}" block>
                                Edit Social Media
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                            <h5>Guild Membership</h5>
                            <template v-if="isMember">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>Verified:&nbsp;</td>
                                        <td><span
                                                :class="{ label: true, warning: !company.membership.verified, success: company.membership.verified }">{{ company.membership.verified }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Guild Number:&nbsp;</td>
                                        <td>{{ company.membership.guildMembershipNumber || 'n/a' }}</td>
                                    </tr>
                                    <tr>
                                        <td>Type:&nbsp;</td>
                                        <td>{{ company.membership.memberType || 'n/a' }}</td>
                                    </tr>
                                    <tr>
                                        <td>Expires:&nbsp;</td>
                                        <td>{{ company.membership.expires ? (new
                                            Date(company.membership.expires).toISOString()).split('T')[0] :
                                            'n/a' }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </template>
                            <p v-else>Not a member</p>
                            <v-btn :to="{name: 'admin.company.manage.membership', params: {uid: company.uid}}" block>
                                Edit Membership
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 md6 lg4>
                            <h5>Tax</h5>
                            <table>
                                <tbody>
                                <tr>
                                    <td>Tax Registered:&nbsp;</td>
                                    <td>{{ taxRegistered }}</td>
                                </tr>
                                <tr>
                                    <td>Tax Number:&nbsp;</td>
                                    <td>{{ company.profile.tax.taxNumber || 'N/A' }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <v-btn v-if="!upgradeRequired" :to="{name: 'admin.company.profile.tax', params: {uid: company.uid}}" block>Edit
                                Tax
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
  export default {
    name: 'CompanyProfile',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      company: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        active: null,
        testRouterTabs: null
      }
    },
    computed: {
      upgradeRequired () {
        if (!this.company.status.hasOwnProperty('version')) return true
        return this.systemConfig.modelVersions.companies !== this.company.status.version
      },
      sysVersion () {
        return this.systemConfig.modelVersions.companies
      },
      version () {
        return this.company.status.version
      },
      emulateURL () {
        return `${this.systemConfig.urls.awards}/overview?company_uid=${this.company.uid}`
      },
      isMember () {
        if (!this.company.hasOwnProperty('membership') || !this.company.membership.hasOwnProperty('guildRegistered')) return false
        return this.company.membership.guildRegistered === 'yes'
      },
      taxRegistered () {
        if (!this.company.hasOwnProperty('profile') || !this.company.profile.hasOwnProperty('tax') || !this.company.profile.tax.hasOwnProperty('taxRegistered')) return 'NO'
        if (typeof this.company.profile.tax.taxRegistered === 'boolean') {
          if (this.company.profile.tax.taxRegistered) return 'YES'
          return 'No'
        }
        return this.company.profile.tax.taxRegistered.toUpperCase()
      },
      turnoverPretty () {
        switch (this.company.profile.stats.turnover) {
          case 'lt1m':
            return 'Less than £1million'
          case '1mto5m':
            return 'Between £1-5million'
          case 'gt5m':
            return 'More than £5million'
          default:
            return 'N/A'
        }
      }
    }
  }
</script>

<style scoped>

</style>